import React from 'react';
import { Link } from 'react-router-dom';

//Import Custom Component
import useViewport from '../features/useViewport';

function Footer() {
  const { width } = useViewport();
  const breakpoint = 382;

  return (
    <footer className="footer">
      {/* <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-center">
              <Link to="#" className="widget-newsletter-title">Otrzymaj kupon o wartości 10 zł na pierwsze zakupy.</Link>
            </div>

            <div className="col-lg-4">
              <p className="widget-newsletter-content">Otrzymuj informacje o wydarzeniach, wyprzedażach i ofertach. <br />
                <span className="widget-newsletter-content">Otrzymaj kupon o wartości 10 zł na pierwsze zakupy.</span>
              </p>
            </div>

            <div className="col-lg-6">
              <form action="#">
                <div className="footer-submit-wrapper">
                  <input type="email" className="form-control" placeholder="Wpisz swój adres e-mail" aria-label="Wpisz swój adres e-mail" />
                  <button type="submit" className="btn">Wyślij</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container">
        <div className="footer-middle">
          <div className="row">
            <div className="col-lg-7 col-sm-12">
              <Link to={`${process.env.PUBLIC_URL}`} className="logo">
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="Buduj.pl" className="mt-2" />
              </Link>

              <div className="row">
                <div className="col-xl-4 col-sm-5 col-6">
                  {
                    width < breakpoint ?
                      <div className="contact-widget email">
                        <div style={{ display: 'inline-block' }}>
                          <h4 className="widget-title">zadzwoń</h4>
                          <a href="tel:+48514627003">+48 514 627 003</a>
                        </div>
                      </div>
                      :
                      <div className="contact-widget phone">
                        <div style={{ display: 'inline-block' }}>
                          <h4 className="widget-title">zadzwoń</h4>
                          <a href="tel:+48514627003">+48 514 627 003</a>
                        </div>
                      </div>
                  }
                </div>

                <div className="col-xl-4 col-sm-4 col-6">
                  <div className="contact-widget email">
                    <h4 className="widget-title">adres e-mail</h4>
                    <a href="mailto:info@buduj.pl">info@buduj.pl</a>
                  </div>
                </div>

                <div className="col-xl-4 col-sm-3 col-3">
                  <div className="contact-widget follow">
                    <h4 className="widget-title">zaobserwuj nas</h4>
                    <div className="social-icons">
                      <a href="https://www.facebook.com/budujpl" title="Facebook Buduj.pl" className="social-icon" target="_blank" rel="noopener noreferrer nofollow"><i className="fab fa-facebook-f"></i></a>
                      <a href="https://www.youtube.com/channel/UC_Q6eLFAdlH-uj5kgmomUDA" title="Youtube Buduj.pl" className="social-icon" target="_blank" rel="noopener noreferrer nofollow"><i className="fab fa-youtube"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-sm-12">
              <div className="row">
                <div className="col-sm-6 col-6">
                  <div className="widget">
                    <h4 className="widget-title">Informacje</h4>
                    <ul className="links" style={{ listStyle: 'none' }}>
                      <li><Link to={`${process.env.PUBLIC_URL}/kontakt`}>Kontakt</Link></li>
                      <li><Link to={`${process.env.PUBLIC_URL}/o-firmie`}>O firmie</Link></li>
                      <li><Link to={`${process.env.PUBLIC_URL}/info/mapa-zasiegu`}>Mapa zasięgu</Link></li>
                      {/*<li><Link to={ `${process.env.PUBLIC_URL}/info/o-ciasteczkach#top` }>Polityka cookies</Link></li>*/}
                      <li><Link to={`${process.env.PUBLIC_URL}/polityka-prywatnosci#top`}>Polityka prywatności</Link></li>
                      <li><Link to={`${process.env.PUBLIC_URL}/serwis-informacyjny`}>Serwis informacyjny</Link></li>
                      <li><Link to={`${process.env.PUBLIC_URL}/regulamin#top`}>Regulamin sklepu internetowego</Link></li>
                      {/* <li><Link to={ `${process.env.PUBLIC_URL}/zaufani-wykonawcy` }>Zaufani wykonawcy</Link></li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6 col-6">
                  <div className="widget">
                    <h4 className="widget-title">Pomoc</h4>
                    <ul className="links" style={{ listStyle: 'none' }}>
                      <li><Link to={`${process.env.PUBLIC_URL}/pomoc-techniczna`}>Pomoc techniczna</Link></li>
                      <li><Link to={`${process.env.PUBLIC_URL}/koszty-i-sposob-dostawy`}>Koszty i sposób dostawy</Link></li>
                      {/*<li><Link to={ `${process.env.PUBLIC_URL}/czas-realizacji-zamowienia` }>Czas realizacji zamówienia</Link></li>*/}
                      <li><Link to={`${process.env.PUBLIC_URL}/zwroty-i-reklamacje`}>Zwroty i reklamacje</Link></li>
                      {/*<li><Link to={ `${process.env.PUBLIC_URL}/formy-platnosci` }>Formy płatności</Link></li>*/}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="widget">
                <ul className="links" style={{ listStyle: 'none' }}>
                  <li><Link to={`${process.env.PUBLIC_URL}/regulamin-programu-partnerskiego-sklepu-stacjonarnego#top`}>Regulamin programu partnerskiego sklepu stacjonarnego</Link></li>
                  <li><Link to={`${process.env.PUBLIC_URL}/regulamin-bonu-podarunkowego#top`}>Regulamin bonu podarunkowego</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="col-lg-12">
            <div className="row align-items-center">
              <div className="col-lg-auto col-sm-auto text-center pl-0 pr-0">
                <p className="footer-copyright">
                  Buduj.pl &copy; {new Date().getFullYear()}. Wszelkie prawa zastrzeżone
                </p>
              </div>
              <div className="col-lg-auto col-sm-auto ml-auto">
                <img src={`${process.env.PUBLIC_URL}/assets/images/przelewy24.webp`} alt="dotpay" width="180px" style={{ width: 114 + 'px', margin: '0 auto' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default React.memo(Footer);